export default {"src":"/_next/static/media/shipping2.7dc6e987.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};